/* eslint-disable react/no-set-state,react/no-string-refs  */
import React from 'react';
import CloseIcon from '@tradera/blueprint/theme/icons/close.svg?jsx';

const Tooltip = ({ content, closeTooltip, visible, position }) => {
    return (
        <div
            data-tooltip
            className={`tooltip-search bp ${position} ${
                visible ? 'tooltip--show' : ''
            }`}>
            <div className="tooltip_html">
                <div className="tooltip-content">{content}</div>
                <CloseIcon
                    className="icon tooltip-close"
                    onClick={closeTooltip}
                />
            </div>
        </div>
    );
};

export default Tooltip;
